var map = {
	"./1.png": 1550,
	"./2.png": 1551,
	"./3.png": 1552,
	"./4.png": 1553,
	"./5.png": 1554,
	"./6.png": 1555,
	"./7.png": 1556,
	"./8.png": 1557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1549;